import { css } from 'styled-components';

// style
import colors from '../../style/colors';

const sizes = {
  micro: '7px',
  tiny: '10px',
  xxs: '16px',
  xs: '24px',
  sm: '32px',
  md: '40px',
  lg: '48px',
  xl: '64px',
  auto: 'auto',
};

const variants = {
  action: css`
    background-color: ${props => props.theme.actionColor};
  `,
  positive: css`
    background: ${colors.positive};
    color: ${colors.positiveBackground};
  `,
  negative: css`
    background: ${colors.negative};
    color: ${colors.negativeBackground};
  `,
  attention: css`
    background: ${colors.attention};
    color: ${colors.attentionBackground};
  `,
  'attention-background': css`
    background: ${colors.attentionBackground};
  `,
  'positive-white': css`
    background: ${colors.positive};
    color: ${colors.white};
  `,
  'negative-dark': css`
    background: ${colors.negativeDark};
    color: ${colors.negativeBackground};
  `,
  gray900: css`
    background: ${colors.gray900};
  `,
  emerald: css`
    background: ${colors.lightEmerald};
    color: ${colors.darkEmerald};
  `,
  gray300: css`
    background: ${colors.gray300};
  `,
  'white-gray-opacity': css`
    background: ${colors.white};
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.24);
  `,
  gray400: css`
    background: ${colors.gray400};
  `,
  gray100: css`
    background: ${colors.gray100};
  `,
  'gray400-outline': css`
    background: ${colors.white};
    border: 2px solid ${colors.gray400};
  `,
  'black-outline': css`
    border: 2px solid ${colors.gray900};
  `,
  highlight: css`
    background: ${colors.highlight};
    color: ${colors.white};
  `,
  pumpkin: css`
    background: ${colors.pumpkin};
  `,
  'pumpkin-light': css`
    background: ${colors.lightPumpkin};
  `,
  violet: css`
    background: ${colors.violet};
  `,
  'violet-light': css`
    background: ${colors.lightViolet};
  `,
  teal: css`
    background: ${colors.teal};
  `,
  'teal-light': css`
    background: ${colors.lightTeal};
  `,
  'action-white-border': css`
    background: ${props => props.theme.actionColor};
    border: 1px solid ${colors.white};
  `,
  'action-light-white-border': css`
    background: ${props => props.theme.actionLight};
    border: 3px solid ${colors.white};
  `,
  'action-light': css`
    background: ${props => props.theme.actionLight};
  `,
  'gray300-border': css`
    border: 1px solid ${colors.gray300};
  `,
  'negative-background': css`
    background: ${colors.negativeBackground};
  `,
  sun: css`
    background: ${colors.lightSun};
    color: ${colors.darkSun};
  `,
  'light-sun': css`
    background: ${colors.lightSun};
    color: ${colors.darkSun};
  `,
  'negative-white': css`
    background: ${colors.negative};
    color: ${colors.white};
  `,
  'white-action': css`
    background: white;
    border: 2px solid ${props => props.theme.actionColor};
  `,
  'black-white-black': css`
    background: black;
    border: 2px solid white;
    box-shadow: 0 0 0 1px black;
  `,
  'action-white-action': css`
    background: ${props => props.theme.actionColor};
    border: 2px solid white;
    box-shadow: 0 0 0 1px ${props => props.theme.actionColor};
    color: ${props => props.theme.actionColor};
  `,
  'negative-transparent': css`
    background: ${colors.transparent};
    color: ${colors.negative};
  `,
  'negative-outline': css`
    background: ${colors.negativeDark};
    border: 2px solid ${colors.white};
  `,
  gray600: css`
    background: ${colors.gray600};
  `,
  'gray800-outline': css`
    background: ${colors.white};
    border: 2px solid ${colors.gray800};
  `,
  'positive-outline': css`
    border: 2px solid ${colors.positive};
  `,
  white: css`
    background: ${colors.white};
  `,
  'shadow-white': css`
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.12);
  `,
  'gray-400-border': css`
    border: 1px solid ${colors.gray400};
    color: ${colors.gray400};
  `,
  black: css`
    background: ${colors.black};
  `,
  'lavender-light': css`
    background: ${colors.lightLavender};
  `,
  'positive-background': css`
    background: ${colors.positiveBackground};
  `,
  'positive-bright': css`
    background-color: ${colors.positiveBright};
  `,
};

export { sizes, variants };
